import { ReleaseStrategy } from '@mews-commander/data-access';
import { WithServiceId } from '@mews-commander/types';
import { TimeUnit } from '@mews/enums';
import { dateRange, dateString, maxInputTextLength, presence, timeString } from '@mews-commander/legacy-form';
import { FormValues } from '../types';

export interface AvailabilityBlockEntityFormStateProps {
    startDate: string | undefined;
    endDate: string | undefined;
    timeUnit: TimeUnit;
}

export const getConstraints = (
    { startDate, endDate, timeUnit }: AvailabilityBlockEntityFormStateProps,
    { blockReleaseStrategy }: FormValues
) => ({
    name: { presence, length: maxInputTextLength },
    state: { presence },
    ...(timeUnit === TimeUnit.Hour
        ? {
              'startValue.date': { dateString, presence },
              'startValue.time': { timeString, presence },
              'endValue.date': { dateString, presence, dateRange: { ...dateRange, startDate, endDate } },
              'endValue.time': { timeString, presence },
          }
        : {
              startValue: { dateString, presence },
              endValue: { dateString, presence, dateRange: { ...dateRange, startDate, endDate } },
          }),
    ...(blockReleaseStrategy === ReleaseStrategy.FixedReleaseUtc
        ? { date: { dateString, presence }, time: { presence, timeString } }
        : {}),
    ...(blockReleaseStrategy === ReleaseStrategy.RollingReleaseOffset
        ? { offsetDays: { presence }, offsetTime: { presence, timeString } }
        : {}),
    rateId: { presence },
    bookerId: { presence },
    externalIdentifier: { length: maxInputTextLength },
});

export interface AvailabilityBlockFormDispatchProps {
    onSubmit: (values: FormValues) => void;
}

export interface BaseFormProps extends WithServiceId {
    form: string;
}
